// Create and open the modal

function floowOpenModal(content) {
  const modal = document.querySelector(".floow-modal");

  if (!modal) {
    // If theres no modal container, create one and put it at the beginning of the body
    const modalText = `
    <div class="floow-modal">
      <div class="floow-modal-background" onclick="floowCloseModal();"></div>
      <div class="floow-modal-content-container">
        <svg 
          class="floow-modal-close"
          onclick="floowCloseModal()"
          role="presentation" stroke-width="2" focusable="false" width="24" height="24" viewBox="0 0 24 24">
            <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343"></path>
        </svg>
        <div class="floow-modal-content"></div>
      </div>
    </div>  
    `;
    const modalHTML = new DOMParser().parseFromString(modalText, 'text/html');
    const modalElement = modalHTML.body.querySelector('.floow-modal');
    document.body.prepend(modalElement);
  }

  // Put the content in the modal
  const modalContent = document.querySelector('.floow-modal-content');
  modalContent.innerHTML = content.innerHTML;

  // Open the modal
  document.querySelector(".floow-modal").setAttribute("open", "");
}


// Close the modal

function floowCloseModal() {
  document.querySelector(".floow-modal").removeAttribute("open");
}